import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Compass, Lock, Loader2 } from "lucide-react";
import { adminLogin } from "@/admin/api";

export default function AdminLogin({ onLoggedIn }) {
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!password) return;
    setSubmitting(true);
    try {
      await adminLogin(password);
      toast.success("Welcome back");
      onLoggedIn();
    } catch (err) {
      toast.error(err?.response?.status === 401 ? "Wrong password" : "Couldn't log in");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-5">
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-sm rounded-3xl bg-white border border-[#E5E0D8] p-7 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.1)]"
      >
        <div className="flex items-center gap-2 mb-6">
          <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#FF5A36] text-white">
            <Compass className="h-4 w-4" />
          </span>
          <span className="font-display font-extrabold text-xl tracking-tight">fourdays · admin</span>
        </div>
        <h1 className="font-display text-2xl font-extrabold tracking-tight text-[#1A1A1A]">
          Sign in to continue
        </h1>
        <p className="text-sm text-[#5C5C5C] mt-1.5">Enter the admin password.</p>

        <div className="mt-6 space-y-1.5">
          <Label htmlFor="admin-pw" className="text-xs font-semibold uppercase tracking-widest text-[#5C5C5C]">
            Password
          </Label>
          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#9a9a9a]" />
            <Input
              id="admin-pw"
              data-testid="admin-password-input"
              type="password"
              autoFocus
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="h-12 pl-9 bg-[#FDFBF7] border-[#E5E0D8] rounded-xl focus-visible:ring-[#FF5A36] focus-visible:ring-offset-0"
            />
          </div>
        </div>

        <Button
          type="submit"
          data-testid="admin-login-submit"
          disabled={submitting}
          className="mt-6 w-full h-12 rounded-xl bg-[#FF5A36] hover:bg-[#E0411F] text-white font-semibold"
        >
          {submitting ? <><Loader2 className="h-5 w-5 animate-spin mr-2" />Signing in</> : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
